import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import type { AppRole } from '@/lib/roleConfig';

const ACTIVE_ROLE_KEY = 'lovable_active_role';

export function useActiveRole(): AppRole | null {
  const { role, roles } = useAuth();
  const [activeRole, setActiveRole] = useState<AppRole | null>(null);

  useEffect(() => {
    const saved = localStorage.getItem(ACTIVE_ROLE_KEY) as AppRole | null;
    setActiveRole(saved && roles.includes(saved) ? saved : role);

    const handler = (e: StorageEvent) => {
      if (e.key === ACTIVE_ROLE_KEY) {
        const newRole = e.newValue as AppRole | null;
        setActiveRole(newRole && roles.includes(newRole) ? newRole : role);
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [role, roles]);

  return activeRole;
}
